export default function getFixedUrl(input) {
  if (input.slice(0, 4) === "http") {
    return input;
  } else if (input.slice(0, 3) === "www") {
    return input.replace("www.", "http://");
  } else {
    return "http://" + input;
  }
}
